<template>
  <div class="grafico-line-faturamento">    
      <div class="row" >
        <div class="col-sm-12 col-md-2 col-lg-2">
            <label for="cbagrupamento">Agrupar por:</label>
            <!-- a position tem que ser relative para que funcione -->
            <select style="position: relative; z-index: 10;" class="form-control form-control-sm" id="cbagrupamento" @change="mtdexecutadash()" v-model="agrupamento">
                <option value="0">Dia</option>
                <option value="1">Mês</option>
                <option value="2">Ano</option>
            </select>
        </div> 
      </div>
      <div class="row">
        <div class="col-md-12" grafico-line style="margin-top: -40px;">
            <graficoline    
                            :titulo="''"
                            :series="seriesgraficoline" 
                            :agrupamento="periodograficoline"
                            :legendas="legendagraficoline"
            ></graficoline>
        </div>
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoLine from '../../components/cmpgraficoline.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "vendascategorias",

  components:{
    'graficoline'		: GraficoLine,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
       
      
        isloading               : false,  

        usuariologado           : this.$store.state.usuario,

        agrupamento             : 0,
        faturamentofil          : [],
        seriesgraficoline       : [],
        periodograficoline      : [],
        legendagraficoline      : [],
        

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdprocessadadosgraficoline(data){
            this.faturamentofil    = Object.values(data);
            this.periodograficoline = this.mtdobterperiodo(this.faturamentofil);
          
            // Substituir mapeamento do legendagraficoline
            
            this.legendagraficoline = [];
            for (let i = 0; i < this.faturamentofil[0].length; i++) {
                this.legendagraficoline.push(this.faturamentofil[0][i].descfil);
            }

            // Substituir mapeamento do seriesgraficoline
            this.seriesgraficoline = [];
            for (let i = 0; i < this.faturamentofil[0].length; i++) {
                const filial = this.faturamentofil[0][i];
                const seriesItem = {
                    name: filial.descfil,
                    type: 'line',
                    stack: 'Total',
                    data: []
                };

                for (let j = 0; j < this.periodograficoline.length; j++) {
                    const periodo = this.periodograficoline[j];
                    const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                    seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalpedido : 0);
                }
                this.seriesgraficoline.push(seriesItem);
            }
        },
        mtdobterperiodo(data){
            let arraydata = data[0];
            const periodos = new Set();
            for (let i = 0; i < arraydata.length; i++) {
                const filial = arraydata[i];
                for (let j = 0; j < filial.dados.length; j++) {
                    const item = filial.dados[j];
                    periodos.add(item.periodo);
                }
            }
            return Array.from(periodos);
        },
        mtdexecutadash(){
            var vself           = this;       
            vself.$emit('handlerLoader', true);      
            let periodo         = ' "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';

            let parametros      = [
                {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor  : 'faturamentoporfilial'},
                {parametro: 'periodo',      valor  : periodo},
                {parametro: 'agrupamento',  valor  : vself.agrupamento},
                {parametro: 'filiais',      valor  : JSON.stringify(vself.lstfiliais)},
          
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
                

                vself.mtdprocessadadosgraficoline(response.data.faturamentofil);
               
            
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.$emit('handlerLoader', false);
            });
        },
  },
  mounted(){
    //Recupera estado do 'agrupar por'
    let agrupamentoStore = localStorage.getItem('agrupamento');

    if(agrupamentoStore){
        this.agrupamento =  parseInt(agrupamentoStore);
    }

    setTimeout(() => {
         this.mtdexecutadash();
    }, 3000);
   
  },
  computed:{
            
  },
  watch:{
    agrupamento(val){
        window.localStorage.setItem('agrupamento', val);
    }
  }
}
</script>
<style>
    @media (max-width: 576px) {
        .grafico-individual .echarts {
            width: 300px;
            height: 400px;
        }        
        .grafico-line-faturamento .echarts{
            width: 300px;
            height: 250px;        
        }        
    }  
    @media (min-width: 577px) {
        .grafico-individual .echarts {
            width: 500px;
            height: 600px;
        }        
        .grafico-line-faturamento .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        .grafico-individual .echarts {
            width: 1024px;
            height: 828px;
        }       
        .grafico-line-faturamento .echarts{
            width: 1024px;
            height: 400px;        
        }        
    }  
</style>
